import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {RESOURCE_USAGES_QUERY_KEY, SNIPPETS_QUERY_KEY} from "../queryKeys";
import {ReachSnippet, ReachSnippetCreatePayload} from "./types";

type UpdateSnippetVariables = ReachSnippetCreatePayload & {id: number};

const updateSnippet = async ({id, ...payload}: UpdateSnippetVariables): Promise<ReachSnippet> => {
  const response = await axiosReachInstance.put<ReachSnippet, AxiosResponse<ReachSnippet>, ReachSnippetCreatePayload>(
    `/snippets/${id}`,
    payload
  );
  return response.data;
};

export const useUpdateSnippet = (
  options?: BaseMutationOptions<ReachSnippet, UpdateSnippetVariables>
): BaseUseMutationResult<ReachSnippet, UpdateSnippetVariables> => {
  return useBaseMutation<ReachSnippet, UpdateSnippetVariables>(updateSnippet, {
    ...options,
    prefixKeysToReset: () => [[SNIPPETS_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY]],
  });
};
